import React from 'react'
import { withTranslation } from 'react-i18next'
import InputPhoneNumber from 'app/domains/common/InputPhoneNumber'
import EditingForm from 'app/domains/common/AdminAndSuperAdminComponents/EditingForm'

const PhoneForm = ({
  t,
  form,
  onSubmit,
  handleClosePopover,
  fullNameOrEmail,
  onRemove,
  phoneWithoutCode,
  initialValues,
}) => {
  return (
    <EditingForm
      onSubmit={onSubmit}
      title={t('user-phone', { user: fullNameOrEmail })}
      form={form}
      handleClosePopover={handleClosePopover}
      initialValues={initialValues}
      isShowDeleteButton={!!phoneWithoutCode}
      onRemove={onRemove}
    >
      <InputPhoneNumber isRequired form={form} />
    </EditingForm>
  )
}

export default withTranslation('admin')(PhoneForm)
